import React from 'react'
import PropTypes from 'prop-types'
import styles from '../styles.module.scss'

const DeliveryInfoModalTitle = ({ deliveryContentData }) => {
    if (!deliveryContentData) return null
    
    return (
        <>
            <p className={styles.modalTitle}>{deliveryContentData['title']}</p>
            {/* TODO: Add subTitle back in for future test */}
            {/* <p className={styles.modalSubtitle}>{deliveryContentData['subtitle']}</p> */}
        </>
    )
}

DeliveryInfoModalTitle.propTypes = {
    deliveryContentData: PropTypes.object
}

export default DeliveryInfoModalTitle
